export default __webpack_public_path__ + "static/media/Blog4_4.cc97f720.jpg";